var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.components.length > 0
    ? _c(
        "div",
        {
          class: [
            "sv-components-column",
            "sv-components-container-" + _vm.container,
          ],
        },
        [
          _vm._l(_vm.components, function (component) {
            return [
              _c(component.component, {
                key: component.index,
                tag: "component",
                attrs: {
                  survey: _vm.survey,
                  container: _vm.container,
                  model: component.data,
                },
              }),
            ]
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }